import { Box, Theme, useMediaQuery } from '@mui/material';
import React from 'react';

interface NotificationBadgeProps {
  notifications: number;
  color?:any;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({ notifications,color }) => {
  if (notifications === 0) {
    return null;
  }
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        position: 'absolute',
        top:!isMobile? '4px':'23px',
        right:!isMobile? '-6px':'50px',
        backgroundColor: 'red', // Naranja
        borderRadius: '50%',
        width: '20px',
        height: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff', // Blanco
        fontSize: '11px',
        fontWeight: 'bold',
        fontFamily: "'DM Sans', sans-serif"
      }}>
      {notifications > 99 ? '99+' : notifications}
    </Box>
  );
};

export default NotificationBadge;
